<template>
	<div class="enterGuide">
		<div class="guide-bann"><img src="../../../image/banner.png" /></div>
		<div class="centerWidth">
			<div class="guide-one">
				<div class="guide-one-bg"><img src="../../../image/edu-b.png" /></div>
				<div class="guide-one-con">
					<div class="one-img"><img src="../../../image/edu-a.png" /></div>
					<div class="one-con">
						首先给大家介绍裸分统招升学途径。裸分统招是指不借助任何一种途径获得高考加分或录取优惠，仅通过参加普通高考进入理想大学的一种方式，目前大多数考生均采用该方式进入理想大学。随着新高考录取模式的增加，裸分上名校的难度也在不断增加。
					</div>
				</div>
			</div>
			<div class="guide-title">
				<p>常见升学途径</p>
				<div class="tit-img"><img src="../../../image/tit.png" /></div>
			</div>
			<article class="guide-way">
				<ul class="way-one">
					<li v-for="(item, index) in wayListA" :key="index" @click="guideInfo(item.TypeId)">
						<div class="way-one-img"><img :src="item.PCImageUrl" /></div>
						<div class="way-one-con">
							<p class="one-con-tit">{{ item.TypeName }}</p>
							<p class="one-con-txt">{{ item.Describe }}</p>
						</div>
					</li>
				</ul>
			</article>
			<div class="guide-title">
				<p>其他主流途径</p>
				<div class="tit-img"><img src="../../../image/tit.png" /></div>
			</div>
			<article class="guide-way">
				<ul class="way-two">
					<li v-for="(item, index) in wayListB" :key="index" @click="guideInfo(item.TypeId)">
						<div class="two-img"><img :src="item.PCImageUrl" /></div>
						<p class="two-txt">{{ item.TypeName }}</p>
					</li>
				</ul>
			</article>
			<div class="guide-title">
				<p>军事/公安类升学</p>
				<div class="tit-img"><img src="../../../image/tit.png" /></div>
			</div>
			<article class="guide-way">
				<ul class="way-three">
					<li v-for="(item, index) in wayListC" :key="index" @click="guideInfo(item.TypeId)">
						<div class="three-img"><img :src="item.PCImageUrl" /></div>
						<p class="three-txt">{{ item.TypeName }}</p>
					</li>
				</ul>
			</article>
			<div class="guide-title">
				<p>其他升学途径</p>
				<div class="tit-img"><img src="../../../image/tit.png" /></div>
			</div>
			<article class="guide-way">
				<ul class="way-three">
					<li v-for="(item, index) in otherList" :key="index" @click="guideInfo(item.TypeId)">
						<div class="three-img"><img :src="item.PCImageUrl" /></div>
						<p class="three-txt">{{ item.TypeName }}</p>
					</li>
				</ul>
			</article>
			<div class="guide-title">
				<p>其他</p>
				<div class="tit-img"><img src="../../../image/tit.png" /></div>
			</div>
			<article class="guide-way">
				<ul class="way-four">
					<li @click="guideInfo(0)">
						<div class="four-img"><img :src="other.PCImageUrl" /></div>
						<div class="four-txt">
							<p>{{ other.TypeName }}</p>
						</div>
					</li>
				</ul>
			</article>
			<!-- <div class="guide-refer">
				<div class="guide-refer-bg"><img src="../../../image/imga.png" /></div>
				<div class="refer-con flex zhong center">
					<div>
						<div class="refer-txt">
							<p class="refer-t01">20余种</p>
							<p class="refer-t02">进入大学的途径!</p>
						</div>
						<div class="refer-txt">
							<p class="refer-t02">您想知道自己</p>
							<p class="refer-t01">适合哪种吗?</p>
						</div>
						<div class="refer-btn">
							<img src="../../../image/search.png" />
							<span>点此查询</span>
						</div>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// 常见升学途径
			wayListA: [],
			// 其他主流途径
			wayListB: [],
			// 军事/公安类升学
			wayListC: [],
			otherList: [],
			// 其他升学途径
			other: {}
		};
	},
	// 加载
	created() {
		if (this.$route.query.key) {
			this.$api.reduceUserCount({ key: this.$route.query.key });
		} else {
			this.$router.back(-1);
		}
		this.GetFurtherGuide();
	},
	methods: {
		GetFurtherGuide(page) {
			var that = this;

			that.$api.HtppRequest(
				'SystemData/GetFurtherGuide',
				'GET',
				{},
				function(res) {
					console.log('获取', res);
					if (res.flag) {
						that.wayListA = res.commonlist;
						// 其他主流途径
						that.wayListB = res.mainStream;
						// 军事/公安类升学
						that.wayListC = res.militaryList;
						// 其他升学途径
						that.otherList = res.otherList;
						// 其他
						that.other = res.other;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// 指南详情
		guideInfo(id) {
			// this.$router.push('/guideinfo');
			this.$router.push({ path: '/guideinfo', query: { id: id } });
		}
	}
};
</script>

<style scoped>
.enterGuide {
	width: 100%;
	height: auto;
}
.guide-bann {
	width: 100%;
	height: 420px;
}
.guide-bann img {
	width: 100%;
	height: 100%;
	display: block;
}
/* guide-one */
.guide-one {
	margin: 50px auto;
	width: 100%;
	height: auto;
	overflow: hidden;
	background: #e5eff8;
	border-bottom: 2px solid #333;
}
.guide-one-bg {
	width: 100%;
	height: 8px;
}
.guide-one-bg img {
	width: 100%;
	height: 100%;
	display: block;
}
.guide-one-con {
	padding: 30px;
	width: 100%;
	display: flex;
}
.one-img {
	width: 40px;
	height: 40px;
	margin-right: 20px;
}
.one-img img {
	width: 100%;
	height: 100%;
	display: block;
}
.one-con {
	width: calc(100% - 60px);
	font-size: 15px;
	color: #333;
	line-height: 28px;
}
/* guide-title */
.guide-title {
	width: 100%;
	display: flex;
	align-items: flex-end;
	margin-top: 10px;
	margin-bottom: 50px;
}
.guide-title p {
	position: relative;
	font-size: 26px;
	color: #333;
	font-weight: bold;
	padding-left: 25px;
	margin-bottom: 10px;
}
.guide-title p::after {
	position: absolute;
	content: '';
	width: 10px;
	height: 10px;
	top: 0;
	left: 0;
	background-color: #333;
	margin-top: 7px;
}
.tit-img {
	width: 121px;
	height: 19px;
	margin-left: -70px;
}
.tit-img img {
	width: 100%;
	height: 100%;
	display: block;
}
/* guide-way */
.guide-way {
	width: 100%;
	height: auto;
	margin-bottom: 20px;
}
/* way-one */
.way-one {
	width: 100%;
	height: auto;
	display: flex;
	flex-wrap: wrap;
}
.way-one li {
	padding: 40px 20px;
	width: 49%;
	height: auto;
	background-color: #fff;
	border-radius: 5px;
	display: flex;
	align-items: center;
	margin-right: 20px;
	margin-bottom: 20px;
}
.way-one li:nth-child(2n + 2) {
	margin-right: 0px;
}
.way-one-img {
	width: 180px;
	height: 130px;
	margin-right: 20px;
	border-radius: 5px;
}
.way-one-img img {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 5px;
}
.way-one-con {
	width: calc(100% - 200px);
	height: auto;
}
.one-con-tit {
	width: 100%;
	font-size: 20px;
	color: #333;
	border-bottom: 1px solid #eee;
	margin-bottom: 20px;
	padding-bottom: 20px;
}
.one-con-txt {
	font-size: 15px;
	color: #333;
}
/* way-two */
.way-two {
	width: 100%;
	height: auto;
	display: flex;
	flex-wrap: wrap;
}
.way-two li {
	width: 23%;
	height: 200px;
	position: relative;
	margin-right: 30px;
	margin-bottom: 30px;
}
.way-two li:nth-child(4n + 4) {
	margin-right: 0px;
}
.two-img {
	width: 100%;
	height: 100%;
	border-radius: 5px;
}
.two-img img {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 5px;
}
.two-txt {
	position: absolute;
	font-size: 18px;
	color: #fff;
	text-align: center;
	bottom: 0;
	width: 100%;
	left: 0;
	padding-bottom: 20px;
}
/* way-three */
.way-three {
	width: 100%;
	height: auto;
	display: flex;
}
.way-three li {
	width: calc(100% / 6);
	height: auto;
}
.three-img {
	width: 130px;
	height: 130px;
	border-radius: 50%;
	margin: 0 auto;
}
.three-img img {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 50%;
}
.three-txt {
	width: 100%;
	font-size: 18px;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	text-align: center;
	margin-top: 20px;
}
/* way-four */
.way-four {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
}
.way-four li {
	width: 23%;
	height: 300px;
	position: relative;
	border-radius: 5px;
	margin-right: 30px;
}
.way-four li:nth-child(4n + 4) {
	margin-right: 0px;
}
.four-img {
	width: 100%;
	height: 100%;
	border-radius: 5px;
}
.four-img img {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 5px;
}
.four-txt {
	position: absolute;
	width: 100%;
	height: 100%;
	border-radius: 5px;
	background: rgba(0, 0, 0, 0.5);
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}
.four-txt p {
	font-size: 18px;
	color: #fff;
	position: relative;
	padding-bottom: 20px;
}
.four-txt p::after {
	position: absolute;
	content: '';
	width: 44px;
	height: 0;
	border: 2px solid #fff;
	border-radius: 50px;
	bottom: 0;
	left: 50%;
	margin-left: -22px;
}
/* guide-refer */
.guide-refer {
	width: 100%;
	height: 280px;
	position: relative;
	margin-top: 50px;
	margin-bottom: 60px;
}
.guide-refer-bg {
	width: 100%;
	height: 100%;
}
.guide-refer-bg img {
	width: 100%;
	height: 100%;
	display: block;
}
.refer-con {
	width: 345px;
	height: 100%;
	background-color: #333;
	position: absolute;
	top: 0;
	left: 45px;
}
.refer-txt {
	width: 100%;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	margin-bottom: 10px;
}
.refer-t01 {
	font-size: 24px;
	color: #ffee2b;
}
.refer-t02 {
	font-size: 18px;
	color: #fff;
}
.refer-btn {
	width: 200px;
	height: 50px;
	background-color: #ffee2b;
	border-radius: 50px;
	margin: 30px auto 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.refer-btn img {
	width: 20px;
	height: 20px;
	display: block;
	margin-right: 10px;
}
.refer-btn span {
	font-size: 18px;
	color: #333;
}
</style>
